import { render, staticRenderFns } from "./TitledSelectionField.vue?vue&type=template&id=4cc96cb6&"
import script from "./TitledSelectionField.vue?vue&type=script&lang=js&"
export * from "./TitledSelectionField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports